export default "__VITE_ASSET__Dsu0vat___"